import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { Grid, Card, CardContent } from '@material-ui/core';
import StandardDialog from './StandardDialog';
//import RenderSelectFieldRedux from './RenderSelectFieldRedux';

const validate = values => {
    const error  = {}
    if (!values.alias) {
        error.alias = "El campo Alias es requerido"
    }
    return error
}

const OwnForm = props => {
    const { handleSubmit, onCancelAction, submitting, pristine } = props
    return  <Card  variant="outlined"> 
                <CardContent>
                    <form onSubmit = {handleSubmit}>
                        <Grid container spacing={3}>
                        
                            <Grid item xs={12} md={12}>
                                <Field
                                    name="alias"
                                    id= "alias"
                                    required
                                    // value= {data.number}
                                    // onChange={handleChangeCedule}
                                    component={ RenderTextFieldRedux }
                                    label="Alias"
                                    type="text"
                                    fullWidth
                                />
                            </Grid>
                            
                            
                            <br></br>
                            <Grid item xs={6} md={6}>
                                <Button 
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    type="submit" 
                                    disabled={pristine || submitting}
                                >
                                    Guardar
                                </Button>
                            </Grid>
                            <Grid item xs={6} md={6}>
                                <Button fullWidth variant="contained" color="primary" onClick = { () => onCancelAction() }>Cancelar</Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
}

const OwnReduxForm = reduxForm(
    {
        form: 'OwnForm',
        validate,
    }
)(OwnForm)


const BeneficiaryOwnFormEdit = props => {
    const {  onCloseBeneficiaryForm, ownBeneficiary, onAcceptClick } = props
    const {open, data } = ownBeneficiary

    const handleSubmit = (values) => {
        onAcceptClick(values)
    }
    
    return (
            <StandardDialog
                title = { 'Editar Cuenta'}
                open = {open}
                handleClose = {onCloseBeneficiaryForm}
            >
                <OwnReduxForm
                    onSubmit = { handleSubmit }
                    onCancelAction = {onCloseBeneficiaryForm}
                    // data = {data}
                    initialValues = {data} />
            </StandardDialog>
    );
};

BeneficiaryOwnFormEdit.propTypes = {
    onCloseBeneficiaryForm: PropTypes.func.isRequired,
    onAcceptClick: PropTypes.func.isRequired,
}

export default BeneficiaryOwnFormEdit;